export default __webpack_public_path__ + "7ef96b3ba44edd85cd86a401d26129c9.svg";